<template>
    <v-dialog v-model="dialog" width="800" @click:outside="closeModal" :retain-focus="false">
        <v-card class="custom-card" rounded="0">
            <v-toolbar flat color="primary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{ $t("esgPlatform.surveyQuestionForTheGoal")
                    }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form ref="form" @submit.prevent="submitForm">
                <v-card-text class="pa-4">
                    <div class="item-box px-6 mt-4" style="align-items: center;">
                        <v-row>
                            <label for="survey" class="text-subtitle-1 font-weight-bold">
                                {{ $t('esgPlatform.selectExistingESGSurveyOrCreateNew') }}
                            </label>
                        </v-row>
                        <v-row>
                            <v-autocomplete dense v-model="survey" :items="existingSurvey" outlined
                                :rules="[rules.required]" required
                                :placeholder="$t('esgPlatform.selectExistingESGSurveyOrCreateNew')">
                            </v-autocomplete>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined class="mr-2" @click="closeModal">
                        {{ $t("cancel") }}
                    </v-btn>
                    <v-btn color="primary" @click="createNewSurvey">
                        {{ $t("esgPlatform.createnewSurvey") }}
                    </v-btn>
                    <v-btn color="primary" @click="submitForm">
                        {{ $t("save") }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import ESGService from "@/_services/EsgService";

export default {
    props: {
        dialogI: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            existingSurvey: [], // Stores the list of available surveys
            survey: '', // Selected survey ID
            questionCount: 0, // Tracks the number of questions in the selected survey
            validationError: false,
            errors: {
                survey: [],
            },
            rules: {
                required: v => !!v || this.$t("esgPlatform.thisfieldIsRequired"),
            },
        };
    },
    computed: {
        dialog() {
            return this.dialogI;
        },
    },
    watch: {
        dialogI(newVal) {
            if (newVal) {
                this.getAssessmentQuestions();
                this.resetComponent();
            }
        },
        survey(newSurvey) {
            const selectedSurvey = this.existingSurvey.find(s => s.value === newSurvey);
            this.questionCount = selectedSurvey ? selectedSurvey.questionCount : 0;
        }
    },
    mounted() {
        this.getAssessmentQuestions();
        this.clearErrors();
    },
    methods: {
        // Fetches the list of ESG assessment surveys
        async getAssessmentQuestions() {
            try {
                const response = await ESGService.getAssessmentQuestions();
                if (response.success) {
                    this.existingSurvey = response.data.map(assessment => ({
                        text: assessment.title,
                        value: assessment._id,
                        questionCount: assessment.noOfQuestions || 0
                    }));
                } else {
                    console.error("Failed to fetch assessments:", response.message);
                }
            } catch (error) {
                console.error("Error fetching assessments:", error);
            }
        },
        // Validates the form before submission
        isValid() {
            this.clearErrors();
            if (!this.survey) {
                this.$set(this.errors, "survey", [this.rules.required]);
                return false;
            }
            return true;
        },
        // Closes the modal and resets the component state
        closeModal() {
            this.resetComponent();
            this.$emit('closeModal');
        },
        // Clears validation errors
        clearErrors() {
            this.errors = { survey: [] };
        },
        // Emits an event to create a new survey
        createNewSurvey() {
            this.$emit('createNewSurvey');
        },
        // Submits the selected survey
        async submitForm() {
            this.validationError = false;
            if (!this.isValid()) {
                this.$notify({
                    type: "error",
                    text: this.$t("esgPlatform.pleaseFillRequiredFields"),
                });
                return;
            }

            const selectedSurvey = this.existingSurvey.find(s => s.value === this.survey);
            this.$emit("surveySelected", {
                survey: this.survey,
                questionCount: selectedSurvey ? selectedSurvey.questionCount : 0,
            });

            this.closeModal();
        },
        // Resets component state to its initial values
        resetComponent() {
            this.survey = '';
            this.questionCount = 0;
            this.clearErrors();
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
        },
    },
};
</script>

<style scoped>
.spaced {
    justify-content: space-between;
}
</style>
